import { render, staticRenderFns } from "./eventRegister.vue?vue&type=template&id=52e533c9&scoped=true"
import script from "./eventRegister.vue?vue&type=script&lang=js"
export * from "./eventRegister.vue?vue&type=script&lang=js"
import style0 from "./eventRegister.vue?vue&type=style&index=0&id=52e533c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e533c9",
  null
  
)

export default component.exports